import Modal from '@/components/Modal';
import BaseModal from '@/components/Modals/BaseModal';
import React from 'react';
const UpgradeRequiredModal = ({ handleOpenModal, isModal }) => {
  const handleUpgradeNow = () => {
    handleOpenModal();
    window.location.href = `${window.location.origin}/account/edit#/memberships`;
  };
  const handleCancel = () => handleOpenModal();
  return (
    <Modal
      isOpen={isModal}
      onRequestClose={handleCancel}
      shouldCloseOnOverlayClick={true}
      additionalStyles={{ maxWidth: '494px' }}
    >
      <BaseModal
        icon='/icons/upgrade-icon.svg'
        title='Membership Upgrade Required'
        text='This action requires a higher membership plan. Please upgrade your plan to access this feature.'
        cancelButton
        primaryButtonText='Upgrade Now'
        handlePrimaryButton={handleUpgradeNow}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};
export default UpgradeRequiredModal;
